import { createSelector } from '@reduxjs/toolkit';

import type { PropsCoreState } from '~/store/interfaces';

import type { QuoteItem, QuoteProduct } from './interfaces';

export const selectQuotes = ({ quotes }: PropsCoreState) => quotes;
export const selectQuotesItems = ({ quotes }: PropsCoreState) => quotes.items;
export const selectQuotesEnabledProducts = ({ quotes }: PropsCoreState) =>
  quotes.enabledProducts;
export const selectWeather = ({ quotes }: PropsCoreState) => quotes.weather;
export const selectQuotesCoords = ({ quotes }: PropsCoreState) => quotes.coords;
export const selectQuotesUf = ({ quotes }: PropsCoreState) => quotes.uf;
export const selectQuotesLoading = ({ quotes }: PropsCoreState) => quotes.loading;
export const selectWeatherLoading = ({ quotes }: PropsCoreState) => quotes.weatherLoading;
export const selectDetailLoading = ({ quotes }: PropsCoreState) => quotes.detailLoading;

export const selectQuotesSettings = createSelector([selectQuotes], (q) => ({
  uf: q.uf,
  useCurrentLocation: q.useCurrentLocation,
  weatherCity: q.weatherCity,
  enabledProducts: q.enabledProducts,
}));

export const selectVisibleQuoteItems = createSelector(
  [selectQuotesItems, selectQuotesEnabledProducts],
  (items, enabled): QuoteItem[] => items.filter((i) => enabled.includes(i.product)),
);

export const selectQuoteDetail = (product: QuoteProduct) =>
  createSelector([selectQuotes], (q) => q.detailByProduct[product]);
